import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../core/style/gstheme';

class ExportAndDownload extends React.Component {

    render() {

        const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];

        return (
            <div data-test="export-download">
                <Grid container spacing={2} classes={
                    {
                        "spacing-xs-2": this.props.classes.fullGrid
                    }
                }>
                    {children.map((child, index) => <Grid key={index} item xs={12} sm={6} md={6}>{child}</Grid>)}
                </Grid>
            </div>
        );
    }
}

ExportAndDownload.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any
};

export default withStyles(styles)(ExportAndDownload);